(() => {
  const nav = document.querySelector('[data-nav]');
  const toggle = document.querySelector('[data-nav-toggle]');
  const closeBtn = document.querySelector('[data-nav-close]');
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchPanel = document.querySelector('[data-search-panel]');
  const searchInput = document.getElementById('HeaderSearchInput');

  const setNavOpen = (open) => {
    if (!nav) return;
    nav.classList.toggle('is-open', open);
    document.body.classList.toggle('nav-open', open);
    if (toggle) toggle.setAttribute('aria-expanded', String(open));
  };

  const setSearchOpen = (open) => {
    if (!searchPanel) return;
    searchPanel.hidden = !open;
    searchToggle?.setAttribute('aria-expanded', String(open));
    if (open) {
      setNavOpen(false);
      searchInput?.focus();
    }
  };

  toggle?.addEventListener('click', () => {
    setSearchOpen(false);
    setNavOpen(!nav.classList.contains('is-open'));
  });
  closeBtn?.addEventListener('click', () => setNavOpen(false));
  searchToggle?.addEventListener('click', () => setSearchOpen(searchPanel?.hidden));

  document.addEventListener('click', (event) => {
    if (nav?.classList.contains('is-open') && !nav.contains(event.target) && !toggle?.contains(event.target)) {
      setNavOpen(false);
    }
    if (searchPanel && !searchPanel.hidden) {
      if (searchPanel.contains(event.target) || searchToggle?.contains(event.target)) return;
      setSearchOpen(false);
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      setNavOpen(false);
      setSearchOpen(false);
    }
  });

  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main]');
    const thumbs = gallery.querySelectorAll('[data-gallery-src]');
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!main) return;
        main.src = thumb.getAttribute('data-gallery-src');
        thumbs.forEach((other) => other.classList.toggle('is-active', other === thumb));
      });
    });
  });

  document.querySelectorAll('.product-form__option').forEach((card) => {
    card.addEventListener('change', () => {
      card.parentElement?.querySelectorAll('.product-form__option').forEach((other) => {
        other.classList.toggle('is-active', other === card);
      });
    });
  });

  document.querySelectorAll('[data-faq]').forEach((item) => {
    const button = item.querySelector('button');
    button?.addEventListener('click', () => {
      const open = item.hasAttribute('open');
      item.closest('[data-faq-list]')
        ?.querySelectorAll('[data-faq]')
        .forEach((other) => other.removeAttribute('open'));
      if (!open) item.setAttribute('open', '');
    });
  });
  document.querySelectorAll('.product-info').forEach((info) => {
    const price = info.querySelector('[data-purchase-price]');
    const updatePrice = () => {
      const selected = info.querySelector('input[name="selling_plan"]:checked');
      if (price && selected?.dataset.priceLabel) price.textContent = selected.dataset.priceLabel;
    };
    info.querySelectorAll('input[name="selling_plan"]').forEach((input) => input.addEventListener('change', updatePrice));
    updatePrice();
  });
})();
